import React, { useContext, useState, useEffect } from "react";
import { apiValue } from "../Data/AllData";
import { Link } from "react-router";
import { useCart } from "react-use-cart";

function Product() {
  const { addItem } = useCart();
  const [search, setsearch] = useState("");
  const api = useContext(apiValue);
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(saved);
  }, []);

  const toggleFavorite = (product) => {
    const exists = favorites.some((item) => item.id === product.id);
    let updated;
    if (exists) {
      updated = favorites.filter((item) => item.id !== product.id);
    } else {
      updated = [...favorites, product];
    }
    setFavorites(updated);
    localStorage.setItem("favorites", JSON.stringify(updated));
    window.dispatchEvent(new Event("favoritesUpdated"));
  };

  const getSearch = (event) => {
    setsearch(event.target.value);
  };

  const filteredProducts = api.filter((element) => {
    if (!search) return true;
    return (
      element.id == search ||
      element.title.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div>
      <div className="container py-5">
        <div className="row">
          <div className="dropdown col-md-2 mb-3">
            <button
              className="btn btn-success dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              select the section
            </button>
            <ul className="dropdown-menu">
              <li>
                <Link className="dropdown-item" to="/phone">
                  phones
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/laptop">
                  laptops
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/shop">
                  product
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-10">
            <input
              onChange={getSearch}
              className="form-control mb-5 col-md-12 w-100"
              type="text"
              name="products"
              placeholder="search for product...."
            />
          </div>

          {filteredProducts.map((element) => (
            <div key={element.id} className="col-md-4 rounded-5 ">
              <div className="card mb-4 product-wap rounded-5">
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    src={element.images[0]}
                  />
                  <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                    <ul className="list-unstyled">
                      <li>
                        <button
                          className="btn btn-success text-white"
                          onClick={() => toggleFavorite(element)}
                        >
                          <i
                            className={
                              favorites.some((item) => item.id === element.id)
                                ? "fas fa-heart"
                                : "far fa-heart"
                            }
                          />
                        </button>
                      </li>
                      <li>
                        <Link
                          className="btn btn-success text-white mt-2"
                          to={`/shopSingle/${element.id}`}
                        >
                          <i className="far fa-eye" />
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={() => addItem(element)}
                          className="btn btn-success text-white mt-2"
                        >
                          <i className="fas fa-cart-plus" />
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <Link
                    to={`/shopSingle/${element.id}`}
                    className="h3 text-decoration-none d-block text-white title-product m-auto"
                  >
                    <b>{element.title}</b>
                  </Link>
                  <br/>
                  <h4 className="text-center mb-0 text-success ">
                    ${element.price}
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Product;
